import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectSession } from '../Module/Auth/Presentation/authSelectors';
import { PATHS } from './paths';

interface AuthGuardProps {
  children?: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const session = useAppSelector(selectSession);
  const location = useLocation();
  
  // session이나 localStorage에 userId가 있는지 확인
  const userIdFromSession = (session as any)?.user?.id;
  const userIdFromStorage = window.localStorage.getItem('missionfund.userId');
  const hasUserId = !!(userIdFromSession || userIdFromStorage);

  if (!hasUserId) {
    // 로그인 페이지로 리다이렉트
    return <Navigate to={PATHS.LOGIN} state={{ from: location }} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default AuthGuard;
